import React from "react";

const TiempoCell = ({ tiempo, detalle = false }) => {
  const futuraDetalle = detalle && tiempo.tipo === "futura";
  const classes = [
    "mr2-cell",
    `is-${tiempo.tipo}`,
    !detalle && tiempo.siguiente ? "is-siguiente" : "",
  ].join(" ");

  return (
    <div className={classes}>
      <div className="mr2-cell-name" title={tiempo.nombre}>
        {tiempo.nombre}
      </div>
      <div className="mr2-cell-values">
        <span className="mr2-cell-real" style={{ color: futuraDetalle ? "#9296a3" : tiempo.realColor }}>
          {futuraDetalle ? "·" : tiempo.real}
        </span>
        <span className="mr2-cell-delta" style={{ color: tiempo.deltaColor }}>
          {futuraDetalle ? "" : tiempo.delta}
        </span>
      </div>
      <div className="mr2-small">prog {tiempo.prog}</div>
    </div>
  );
};

const SalidaRow = ({ row, abierto, onToggle }) => {
  const { sev, salida } = row;

  return (
    <div className="mr2-row" style={{ borderLeftColor: sev.color }}>
      <div className="mr2-grid mr2-row-main" onClick={onToggle}>
        <div className="mr2-stack">
          <div className="mr2-unidad">{row.unidad}</div>
          <div className="mr2-small">#{salida.no ?? salida.id}</div>
        </div>

        <div className="mr2-stack">
          <div className="mr2-ramal" title={row.ramalNombre}>
            {row.ramalNombre}
          </div>
          <div className="mr2-small">
            Salió {row.horaSalida} · {row.pctLabel}
          </div>
          {salida.salida_ruta && <span className="mr2-badge">Salida de ruta {salida.salida_ruta}</span>}
        </div>

        <div className="mr2-stack" style={{ gap: 6 }}>
          <div className="mr2-track">
            <div className="mr2-track-line" />
            <div className="mr2-track-fill" style={{ width: `${row.pct}%`, background: sev.color }} />
            {row.ticks.map((t) => (
              <div key={t.key} className="mr2-tick" style={{ left: `${t.left}%`, background: t.color }} />
            ))}
            <div
              className={`mr2-dot${row.pulse ? " is-pulse" : ""}`}
              style={{ left: `${row.pct}%`, background: sev.color, boxShadow: `0 0 0 1px ${sev.color}` }}
            />
          </div>
          <div className="mr2-tiempos">
            {row.tiempos.map((t) => (
              <TiempoCell key={t.key} tiempo={t} />
            ))}
          </div>
        </div>

        <div className="mr2-right">
          <div className="mr2-desv" style={{ color: sev.text }}>
            {row.desvLabel}
          </div>
          <div className="mr2-desv-label" style={{ color: sev.text }}>
            {sev.label}
          </div>
        </div>

        <div className="mr2-right">
          <div className="mr2-llegada">{row.llegadaProy}</div>
          <div className="mr2-small">prog. {row.llegadaProg}</div>
        </div>

        <div className="mr2-right">
          <div className="mr2-restan">{row.restanMin} min</div>
          <div className="mr2-small">{row.restanParadas} por pasar</div>
        </div>

        <div className="mr2-caret">{abierto ? "▾" : "▸"}</div>
      </div>

      {abierto && (
        <div className="mr2-detail">
          <div className="mr2-detail-meta">
            <span>
              <b>Destino</b> {salida.destination || "—"}
            </span>
            <span>
              <b>Operador</b> {salida.operator_name || "—"}
            </span>
            <span>
              <b>Min. quemados</b> {salida.min_quemados ?? 0} min
            </span>
            <span>
              <b>Lecturas</b> {row.lecturas}
            </span>
            <span>Programado / real / desviación por geocerca</span>
          </div>
          <div className="mr2-paradas">
            {row.paradas.map((p) => (
              <TiempoCell key={p.key} tiempo={p} detalle />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SalidaRow;
